import React, { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import ScraperTargetsManager from "../Components/ScraperTargetsManager";
import CompetitorPricesCard from "../Components/CompetitorPricesCard";
import EditRatePrice from "./EditRatePrice";
import { fetchMarketComparableRates } from "../utils/marketComparisonRates";

export default function MarketIntelligenceView({ forcedView = "rules" }) {
  const [searchParams] = useSearchParams();
  const businessUnitId = searchParams.get("business_unit_id") || "1";

  const [rates, setRates] = useState([]);
  const [loadingRates, setLoadingRates] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    if (forcedView !== "internal-vs-market") return;

    let cancelled = false;

    const load = async () => {
      setLoadingRates(true);
      const rows = await fetchMarketComparableRates({ businessUnitId });
      if (!cancelled) {
        setRates(rows);
        setActiveIndex(0);
        setLoadingRates(false);
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [businessUnitId, forcedView]);

  const canGoCarousel = rates.length > 1;
  const activeRate = useMemo(() => rates[activeIndex] || null, [activeIndex, rates]);

  const goPrev = () => {
    if (!rates.length) return;
    setActiveIndex((prev) => (prev - 1 + rates.length) % rates.length);
  };

  const goNext = () => {
    if (!rates.length) return;
    setActiveIndex((prev) => (prev + 1) % rates.length);
  };

  if (forcedView === "rules") {
    return <ScraperTargetsManager />;
  }

  if (forcedView === "competitors") {
    return <CompetitorPricesCard businessUnitId={Number(businessUnitId)} />;
  }

  if (loadingRates) return null;

  if (!rates.length) {
    return (
      <div className="text-white text-center mt-4 fs-5">
        No room rates with market comparison data from yesterday onward.
      </div>
    );
  }

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <div
        className="d-flex justify-content-between align-items-center mb-2 px-1"
        style={{ gap: 10 }}
      >
        <div className="text-warning fw-bold" style={{ fontSize: "0.98rem" }}>
          Market Benchmark by Room Rate
        </div>
        <div className="text-white-50" style={{ fontSize: "0.84rem" }}>
          {activeRate?.label} ({activeIndex + 1}/{rates.length})
        </div>
      </div>

      {canGoCarousel && (
        <button
          type="button"
          onClick={goPrev}
          className="btn btn-sm btn-outline-light"
          style={{
            position: "fixed",
            left: "86px",
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 20,
            borderRadius: "999px",
            width: 34,
            height: 34,
            padding: 0,
            fontWeight: 700,
          }}
          title="Previous room rate"
        >
          {"<"}
        </button>
      )}

      {canGoCarousel && (
        <button
          type="button"
          onClick={goNext}
          className="btn btn-sm btn-outline-light"
          style={{
            position: "fixed",
            right: "20px",
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 20,
            borderRadius: "999px",
            width: 34,
            height: 34,
            padding: 0,
            fontWeight: 700,
          }}
          title="Next room rate"
        >
          {">"}
        </button>
      )}

      <EditRatePrice
        roomRateId={activeRate?.id}
        forcedTab="market"
        hideViewTabs={true}
      />
    </div>
  );
}
